/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "../../orders/orders.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { withTranslation } from "react-i18next";
import Checkbox from "@mui/material/Checkbox";
import Button from "../../../../component/button";

//ProductStatus, ManufacturerPartNumber, QuantityAvailable, DigiKeyPartNumber, ProductDescription
const PartSearchTable = (props) => {
  const t = props.t;
  return (
    <div className={classes.root}>
      <div>
        <Button
          style={{ float: "left", marginLeft: "8px" }}
          onClick={(event) => props.importSelectedItems()}
        >
          {props.t("IMPORT")}
        </Button>
      </div>
      <TableContainer>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>{props.t("IMPORT")}</TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {}}
              >
                <b>{t("Manufacturer_Part_Number")}</b>
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {}}
              >
                <b>{t("Part_Number")}</b>
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {}}
              >
                <b>{t("DESCRIPTION")}</b>
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {}}
              >
                <b>{t("Quantity_Available")}</b>
              </TableCell>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {}}
              >
                <b>{t("STATUS")}</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Show parts list */}

            {props.parts.map((row) => (
              <TableRow
                style={{ cursor: "pointer" }}
                key={row.DigiKeyPartNumber}
              >
                <TableCell>
                  <Checkbox
                    color="primary"
                    checked={row.import}
                    onChange={() =>
                      props.updateImportSelection(row.DigiKeyPartNumber)
                    }
                    name={"import_" + row.DigiKeyPartNumber}
                  />
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.ManufacturerPartNumber}
                </TableCell>
                <TableCell>{row.DigiKeyPartNumber}</TableCell>
                <TableCell>{row.ProductDescription}</TableCell>
                <TableCell>{row.QuantityAvailable}</TableCell>
                <TableCell>{row.ProductStatus}</TableCell>
              </TableRow>
            ))}
            {/* If there is no parts to show */}
            {props.parts.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  {t("No_Parts_Found")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default withTranslation("translations")(PartSearchTable);
